/** Sorting / Grouping  */
// Browser Locales have wildly different rules on how hours are displayed e.g. 00 Vs 24 Vs 01 etc
const LOCALE_INTERNAL = 'en-GB';

export const intlPartsReducer = (prev, current) => {
    prev[current.type] = current.value;
    return prev
};


/**Return pseudo-ISO date, in LOCAL time.
 * dateObj.toISOString() won't work west of UTC because while the local time might be 2022-12-01 00:00:00 America/New Youk
 * the toISOString() output is UTC - so it'll return 2022-11-30 19:00:00-05:00
 * and ALL OUR DATES WILL BE OFF BY ONE! :-(
  */
export const dateToLocalISO = (dateObj) => {
    let year = String(dateObj.getFullYear());
    let month = String(dateObj.getMonth() +1).padStart(2,"0");
    let dom = String(dateObj.getDate()).padStart(2,"0");
    return `${year}-${month}-${dom}`;
};


// var num_datetokey = 0;
// var num_datetohour = 0;
// var num_datetohourkey = 0;
/** Convert a date to a timezone-aware YYYY-MM-DD string for grouping by date
 *
 * @param {Date} dateObj
 * @param {string} timezone
 * @returns {string} - YYYY-MM-DD formatted
 */
export const dateToKey = (dateObj, timezone) => {
    if (!timezone) {
        // console.log("dateToKey:substring()", dateObj, timezone, dateObj.toISOString().substring(0,10));
        return dateToLocalISO(dateObj)
        // return dateObj.toISOString().substring(0,10);
    }
    let formatter = new Intl.DateTimeFormat(LOCALE_INTERNAL, {
        // Include year?
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: timezone,
    });
    // num_datetokey++;
    // console.log("dateToKey", num_datetokey);
    let parts = formatter.formatToParts(dateObj).reduce(intlPartsReducer, {});
    return `${parts.year}-${parts.month}-${parts.day}`;
};


/** Calculate a timezone-aware hour value 
 * 
 * @param {Date} dateObj
 * @param {string} timezone
 * @param {max} Bool - If True, get the end of the hour e.g. 18:05 would return 19
 * @returns {Number} - Hour
 */
export const dateToHour = (dateObj, timezone, max=false) => {
    let formatter = new Intl.DateTimeFormat(LOCALE_INTERNAL, {
        // Include year?
        hour: 'numeric',
        hour12: false,
        timeZone: timezone,
    });
    // num_datetohour++;
    // console.log("dateToHour", num_datetohour);
    let parts = formatter.formatToParts(dateObj).reduce(intlPartsReducer, {});
    let offset = 0;
    if (max) {
        if (dateObj.getMinutes() > 0) { offset = 1; }
    }
    return Number(parts.hour) + offset;
};

/** Generate a timezone-sensitive day&hour&minute key string.
 * We have to include the day because otherwise 24hour events could get duplicate keys.
 */
export const dateToHourKey = (rawDateObj, timezone) => {
    let dateObj = fudgeMinutes5(rawDateObj);

    if (!timezone) {
        let day = String(dateObj.getDate()).padStart(2,"0");
        let hour = String(dateObj.getHours()).padStart(2,"0");
        let minute = String(dateObj.getMinutes()).padStart(2,"0");
        return "hour"+day+hour+minute;
    }
    
    let formatter = new Intl.DateTimeFormat(LOCALE_INTERNAL, {
    // let formatter = new Intl.DateTimeFormat("en-GB", {
    // let formatter = new Intl.DateTimeFormat(navigator.language, {
        // Include year?
        day: '2-digit',
        hour: '2-digit', // 'numeric',
        minute: '2-digit', // 'numeric',
        hour12: false,
        timeZone: timezone,
    });
    // num_datetohourkey++;
    // console.log("dateToHourKey", num_datetohourkey);
    let parts = formatter.formatToParts(dateObj).reduce(intlPartsReducer, {});
    return `hour${parts.day}${parts.hour}${parts.minute}`;
};

/** Grid only works in 15min increments, so we have to modify the output */
export const fudgeMinutes15 = (rawDateObj) => {
    let dateObj = new Date(rawDateObj);
    if (dateObj.getMinutes() < 8) {
        dateObj.setMinutes(0);
    } else if (dateObj.getMinutes() < 23) {
        dateObj.setMinutes(15);
    } else if (dateObj.getMinutes() < 38) {
        dateObj.setMinutes(30);
    } else if (dateObj.getMinutes() < 53) {
        dateObj.setMinutes(45);
    } else {
        // Push to next hour
        dateObj.setMinutes(0);
        dateObj.setHours(dateObj.getHours()+1);
    }
    return dateObj;
};

export const fudgeMinutes5 = (rawDateObj) => {
    let dateObj = new Date(rawDateObj);
    let fudge = dateObj.getMinutes() % 5;
    if (fudge == 0) { return dateObj; }
    
    if (fudge < 3) {
        dateObj.setMinutes( dateObj.getMinutes() - fudge);
    } else {
        dateObj.setMinutes( dateObj.getMinutes() + (5-fudge));
    }
    return dateObj;
    /*
    if (dateObj.getMinutes() < 8) {
        dateObj.setMinutes(0);
    } else if (dateObj.getMinutes() < 23) {
        dateObj.setMinutes(15);
    } else if (dateObj.getMinutes() < 38) {
        dateObj.setMinutes(30);
    } else if (dateObj.getMinutes() < 53) {
        dateObj.setMinutes(45);
    } else {
        // Push to next hour
        dateObj.setMinutes(0);
        dateObj.setHours(dateObj.getHours()+1);
    }
    return dateObj;
    */
};

/** Custom groupBy that converts a string => dateObj => date for the grouping
 * 
 * @param {Object[]} objectArray - List of Meetings/Appointment objects
 * @param {string} property - Name of the property containing a date
 * @param {string} timezone - Timezone to use for comparison
 */ 
export const groupByDate = (objectArray, property, timezone) => {
    // let formatter = new Intl.DateTimeFormat(navigator.language, {
    //     // Include year?
    //     month: '2-digit',
    //     day: '2-digit',
    //     timeZone: timezone,
    // });
    let cleaned = objectArray.filter(cur => cur[property]);
    cleaned.sort(compareStartTime);

    // return objectArray.reduce(function (acc, obj) {
    return cleaned.reduce(function (acc, obj) {
        // Discard items that don't have the property
        if (!obj[property]) {
            return acc;
        }

        let curDate = new Date(obj[property]);
        
        // let key = formatter.format(curDate);
        let key = dateToKey(curDate, timezone);
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})
};

export const groupByDateRange = (objectArray, property_start, property_end, timezone) => {

    let cleaned = objectArray.filter(cur => cur[property_start]);
    cleaned.sort(compareStartTime);

    // return objectArray.reduce(function (acc, obj) {
    return cleaned.reduce(function (acc, obj) {
        // Discard items that don't have the properties
        if (
                (!obj[property_start]) ||
                (!obj[property_end])
        ) {
            return acc;
        }

        let curStartDate = new Date(obj[property_start]);
        let curEndDate = new Date(obj[property_end]);
        
        // let key = formatter.format(curDate);
        let keyStart = dateToKey(curStartDate, timezone);
        let keyEnd = dateToKey(curEndDate, timezone);

        if (!acc[keyStart]) {
            acc[keyStart] = []
        }
        acc[keyStart].push(obj)  

        if (keyStart != keyEnd) {
            if (!acc[keyEnd]) {
                acc[keyEnd] = []
            }
            acc[keyEnd].push(obj)    
        }
        return acc
    }, {});
};

// https://learnwithparam.com/blog/how-to-group-by-array-of-objects-using-a-key/
export const groupBy = (array, key) => {
    // Return the end result
    return array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
};


/** Function to be used in Array.sort() to order by date
 *
 * @param a
 * @param b
 * @returns {number}
 */
 export const compareCreatedAt = (a, b) => {
    if (a.created_at < b.created_at) { return -1; }
    if (a.created_at > b.created_at) { return 1; }
    return 0;
};

/** Function to be used in Array.sort() to order by order_weight
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const compareOrderWeight = (a, b) => {
    if (a.order_weight < b.order_weight) { return -1; }
    if (a.order_weight > b.order_weight) { return 1; }
    return 0;
};

export const compareStartTime = (a, b) => {
    if (a.start_time < b.start_time) { return -1; }
    if (a.start_time > b.start_time) { return 1; }
    return 0;
};
export const compareStartTimeDbg = (a, b) => {
    if (a.startObj < b.startObj) { console.log(`Item ${a.id} ${a.start_time} before ${b.id} ${b.start_time}`)
        return -1; }
    if (a.startObj > b.startObj) { console.log(`Item ${a.id} ${a.start_time} after ${b.id} ${b.start_time}`)
        return 1; }
    console.log(`Item ${a.id} ${a.start_time} same as ${b.id} ${b.start_time}`)
    return 0;
};

export const compareStartTimeUTC = (a, b) => {
    if (a.start_time_utc < b.start_time_utc) { return -1; }
    if (a.start_time_utc > b.start_time_utc) { return 1; }
    return 0;
};

export const compareAttendeeName = (a, b) => {
    let nameA = a.attendee_name.toUpperCase();
    let nameB = b.attendee_name.toUpperCase();
    if (nameA < nameB) { return -1; }
    if (nameA > nameB) { return 1; }
    return 0;
};

export const compareSenderName = (a, b) => {
    let nameA = a.sender_name.toUpperCase();
    let nameB = b.sender_name.toUpperCase();
    if (nameA < nameB) { return -1; }
    if (nameA > nameB) { return 1; }
    return 0;
};

export const compareBy = (key) => (a, b) => {
    let fieldA = a[key].toUpperCase();
    let fieldB = b[key].toUpperCase();
    if (fieldA < fieldB) { return -1; }
    if (fieldA > fieldB) { return 1; }
    return 0;
}


// export const compareOtherLastName = (a, b) => {
//     return compareBy
// }

/** Sort based on last_name.
 * If last_name isn't set, fall back to attempting 'initial' and full_name fields.
 * Django API pre-calculates the 'initial' field based on the either last or first_name.
 *
 * @param a {object}
 * @param b {object}
 * @returns {number}
 */
export const compareLastName = (a, b) => {
    let nameA = '-';
    let nameB = '-';
    if (a.last_name) {
        nameA = a.last_name.toUpperCase();
    } else if (a.initial) {
        nameA = a.initial.toUpperCase();
    } else if (a.full_name) {
        nameA = a.full_name.toUpperCase();
    }
    if (b.last_name) {
        nameB = b.last_name.toUpperCase();
    } else if (b.initial) {
        nameB = b.initial.toUpperCase();
    } else if (b.full_name) {
        nameB = b.full_name.toUpperCase();
    }

    if (nameA < nameB) { return -1; }
    if (nameA > nameB) { return 1; }
    return 0;
};

